import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ApiClientService } from '../../services/api-client.service';

@Injectable()
export class UsersService extends ApiClientService {
  urlPath: string = `/users`;

  constructor(api: ApiService) {
    super(api);
  }
}
